import fetch from "../fetch";

export default ({ values, saleId }) => {
  return fetch({
    path: saleId ? `/re/sales/${saleId}` : "/re/sales",
    method: saleId ? "PUT" : "POST",
    data: values
  });
};
